module.exports = __webpack_public_path__ + "static/media/unsw.c9e91a99.png";